import { getLastSeenFormatter } from '@/features/timeformatter';
import { useUserDetails } from '@/features/users';
import { getLastSeen } from '@/infrastructure/sdk';
import { getUserIdFromJid, logger } from '@/shared/utils';
import { useEffect, useState } from 'react';

const ONLINE = 'online',
   EMPTY_OBJ = {};

export const useLastSeen = (jid, status) => {
   const id = getUserIdFromJid(jid);
   const userDetails = useUserDetails(id, ['isBlockedByMe', 'isBlockedMe', 'isDeleted']) || EMPTY_OBJ;
   const { isBlockedByMe, isBlockedMe, isDeleted } = userDetails;

   const [fetchedData, setFetchedData] = useState({ lastSeen: '', userPresenceStatus: '' });

   useEffect(() => {
      // Return early with empty state if blocking is involved, so we don't query
      if (!jid || isBlockedByMe === 1 || isBlockedMe === 1 || isDeleted) {
         return;
      }

      if (status === ONLINE) return;

      let cancel = false;
      (async () => {
         try {
            const response = await getLastSeen(jid);
            if (cancel) return;

            const { data: { seconds = -1 } = {} } = response || {};
            let s = seconds;
            if (status === 'unavailable' && s === 0) s = 1;

            if (s === 0 && !status) {
               setFetchedData({ lastSeen: 'Online', userPresenceStatus: ONLINE });
            } else {
               setFetchedData({
                  lastSeen: s >= 0 ? getLastSeenFormatter(s) : '',
                  userPresenceStatus: status || (s >= 0 ? 'unavailable' : ''),
               });
            }
         } catch (err) {
            logger.log('getLastSeen error', err);
         }
      })();

      return () => {
         cancel = true;
      };
   }, [jid, status, isBlockedByMe, isBlockedMe, isDeleted]);

   // Do not show "Online" status if the user is blocked, blocking us, or if JID is empty
   if (!jid || isBlockedByMe === 1 || isBlockedMe === 1 || isDeleted) {
      return { lastSeen: '', userPresenceStatus: '' };
   }

   if (status === ONLINE) {
      return { lastSeen: 'Online', userPresenceStatus: ONLINE };
   }

   return fetchedData;
};
